// extracted by mini-css-extract-plugin
export default {"card":"reportingCards_card__zTImD","cardTitle":"reportingCards_cardTitle__kwYeI","cardAmount":"reportingCards_cardAmount__hvQI1"};